/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchAllShifts} from '../api'

export const useMutationSearchAllShifts = createReactQueryMutationHook('searchAllShifts', searchAllShifts)
